import gql from "graphql-tag";
import {IGeometryNode} from "../types";
import {client} from "./client";
import {FetchResult} from "apollo-link"
import {UpdateEntitygeometryByFulluid} from "../../schema/UpdateEntitygeometryByFulluid";
import {EntitygeometryPatch} from "../../types";

const getMutation = (fullUid: string, patchObject: EntitygeometryPatch) => ({
    mutation: gql`${UpdateEntitygeometryByFulluid}`,
    variables: {
        fullUid,
        patchObject,
    }
});

export async function updateEntityGeometryByFullUid (fullUid: string, entityGeometryPatchObject: {[key: string]: any}):
    Promise<IGeometryNode> {
    const result: FetchResult<{ updateEntitygeometryByFullUid: { entitygeometry: IGeometryNode } }> = await client.mutate(getMutation(fullUid, entityGeometryPatchObject));
    const {entitygeometry} = result.data?.updateEntitygeometryByFullUid!;
    if (!entitygeometry) {
        throw new Error('failed to create geom');
    } else {
        client.cache.reset();
        return entitygeometry;
    }
}

